import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "form-horizontal",
  role: "form"
}
const _hoisted_2 = { class: "form-body" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "control-label" }
const _hoisted_7 = { class: "error-msg" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "control-label" }
const _hoisted_10 = { class: "error-msg" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "control-label" }
const _hoisted_13 = { class: "error-msg" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "control-label" }
const _hoisted_16 = { class: "error-msg" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "control-label" }
const _hoisted_19 = { class: "error-msg" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "control-label" }
const _hoisted_22 = { class: "error-msg" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "control-label" }
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "control-label" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-md-12" }
const _hoisted_30 = { class: "control-label" }
const _hoisted_31 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_32 = ["value"]
const _hoisted_33 = ["src", "alt"]
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = {
  class: "container-fluid",
  style: {"border":"1px dashed #808080","padding":"15px"}
}
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-md-12 mb-3" }
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = { class: "control-label" }
const _hoisted_40 = { class: "error-msg" }
const _hoisted_41 = { class: "col-md-6" }
const _hoisted_42 = { class: "control-label" }
const _hoisted_43 = { class: "error-msg" }
const _hoisted_44 = { class: "col-md-6" }
const _hoisted_45 = { class: "control-label" }
const _hoisted_46 = { class: "error-msg" }
const _hoisted_47 = { class: "col-md-6" }
const _hoisted_48 = { class: "control-label" }
const _hoisted_49 = { class: "error-msg" }
const _hoisted_50 = { class: "col-md-6" }
const _hoisted_51 = { class: "control-label" }
const _hoisted_52 = { class: "error-msg" }
const _hoisted_53 = { class: "pull-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_select = _resolveComponent("vue-select")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    ref: "core",
    nested: false
  }, {
    header: _withCtx(() => [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t('components.vehicles.modals.editVehicle')), 1)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('components.vehicles.modals.registration')), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v.vehicle.registration.$model) = $event)),
                  class: _normalizeClass([{ 'custom-error': _ctx.v.vehicle.registration.$error }, "form-control input-sm"]),
                  placeholder: "CBY 2A561",
                  type: "text"
                }, null, 2), [
                  [_vModelText, _ctx.v.vehicle.registration.$model]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v.vehicle.registration.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "vuelidate-errors"
                  }, [
                    _createElementVNode("p", _hoisted_7, _toDisplayString(error.$message), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('components.vehicles.modals.name')), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v.vehicle.vars.name.$model) = $event)),
                  class: _normalizeClass([{ 'custom-error': _ctx.v.vehicle.vars.name.$error }, "form-control input-sm"]),
                  placeholder: "Scania V8",
                  type: "text"
                }, null, 2), [
                  [_vModelText, _ctx.v.vehicle.vars.name.$model]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v.vehicle.vars.name.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "vuelidate-errors"
                  }, [
                    _createElementVNode("p", _hoisted_10, _toDisplayString(error.$message), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('components.vehicles.modals.vinNumber')), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v.vehicle.vin.$model) = $event)),
                  class: _normalizeClass([{ 'custom-error': _ctx.v.vehicle.vin.$error }, "form-control input-sm"]),
                  placeholder: "ABCD1234567890246",
                  type: "text"
                }, null, 2), [
                  [_vModelText, _ctx.v.vehicle.vin.$model]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v.vehicle.vin.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "vuelidate-errors"
                  }, [
                    _createElementVNode("p", _hoisted_13, _toDisplayString(error.$message), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('components.vehicles.modals.driver')), 1),
                _createVNode(_component_vue_select, {
                  modelValue: _ctx.v.vehicle.driver.$model,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v.vehicle.driver.$model) = $event)),
                  class: _normalizeClass([{ 'custom-error': _ctx.v.vehicle.driver.$error }, "flex-grow vue-select"]),
                  options: _ctx.drivers,
                  value: _ctx.selectedDriver,
                  icon: "bi bi-person-fill",
                  label: "name",
                  onUpdateSelect: _ctx.getDriver
                }, null, 8, ["modelValue", "class", "options", "value", "onUpdateSelect"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v.vehicle.driver.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "vuelidate-errors"
                  }, [
                    _createElementVNode("p", _hoisted_16, _toDisplayString(error.$message), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('components.vehicles.modals.phone')), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v.vehicle.vars.phone.$model) = $event)),
                  class: _normalizeClass([{ 'custom-error': _ctx.v.vehicle.vars.phone.$error }, "form-control input-sm"]),
                  placeholder: "+48 508 509 123",
                  type: "text"
                }, null, 2), [
                  [_vModelText, _ctx.v.vehicle.vars.phone.$model]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v.vehicle.vars.phone.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "vuelidate-errors"
                  }, [
                    _createElementVNode("p", _hoisted_19, _toDisplayString(error.$message), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('components.vehicles.modals.virtualOdometer')), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.v.vehicle.vars.virtual_odometer.$model) = $event)),
                  class: _normalizeClass([{ 'custom-error': _ctx.v.vehicle.vars.virtual_odometer.$error }, "form-control input-sm"]),
                  placeholder: "500000",
                  type: "number"
                }, null, 2), [
                  [_vModelText, _ctx.v.vehicle.vars.virtual_odometer.$model]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v.vehicle.vars.virtual_odometer.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "vuelidate-errors"
                  }, [
                    _createElementVNode("p", _hoisted_22, _toDisplayString(error.$message), 1)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('components.vehicles.modals.visibleOnMap')), 1),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.vehicle.vars.visible) = $event)),
                    type: "checkbox"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.vehicle.vars.visible]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('components.vehicles.dataGrids.etoll')), 1),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.vehicle.device.etoll) = $event)),
                    "true-value": true,
                    "false-value": false
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.vehicle.device.etoll]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('components.vehicles.modals.iconOnMap')), 1),
                _createElementVNode("div", _hoisted_31, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.icons, (icon) => {
                    return (_openBlock(), _createElementBlock("label", {
                      key: icon.id,
                      class: "icon-radio"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        class: "invisible",
                        type: "radio",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.vehicle.vars.icon_id) = $event)),
                        value: icon.id
                      }, null, 8, _hoisted_32), [
                        [
                          _vModelRadio,
                          _ctx.vehicle.vars.icon_id,
                          void 0,
                          { number: true }
                        ]
                      ]),
                      _createElementVNode("img", {
                        src: icon.src,
                        alt: `icon ${icon.id}`,
                        class: "icon-thumb"
                      }, null, 8, _hoisted_33)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("h5", null, _toDisplayString(_ctx.$t('components.vehicles.modals.tankHeadline')), 1)
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t('components.vehicles.modals.tankCapacity')) + " 1 (L)", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.v.vehicle.tank_capacity.$model) = $event)),
                    class: _normalizeClass([{ 'custom-error': _ctx.v.vehicle.tank_capacity.$error }, "form-control input-sm input_tank"]),
                    placeholder: "600",
                    type: "number"
                  }, null, 2), [
                    [_vModelText, _ctx.v.vehicle.tank_capacity.$model]
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v.vehicle.tank_capacity.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: error.$uid,
                      class: "vuelidate-errors"
                    }, [
                      _createElementVNode("p", _hoisted_40, _toDisplayString(error.$message), 1)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.$t('components.vehicles.modals.tankCapacity')) + " 2 (L)", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.v.vehicle.tank_capacity2.$model) = $event)),
                    class: _normalizeClass([{ 'custom-error': _ctx.v.vehicle.tank_capacity2.$error }, "form-control input-sm input_tank"]),
                    placeholder: "600",
                    type: "number"
                  }, null, 2), [
                    [_vModelText, _ctx.v.vehicle.tank_capacity2.$model]
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v.vehicle.tank_capacity2.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: error.$uid,
                      class: "vuelidate-errors"
                    }, [
                      _createElementVNode("p", _hoisted_43, _toDisplayString(error.$message), 1)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.$t('components.vehicles.modals.tankCapacity')) + " Ad-Blue (L)", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.v.vehicle.tank_ad_blue.$model) = $event)),
                    class: _normalizeClass([{ 'custom-error': _ctx.v.vehicle.tank_ad_blue.$error }, "form-control input-sm"]),
                    placeholder: "600",
                    type: "number"
                  }, null, 2), [
                    [_vModelText, _ctx.v.vehicle.tank_ad_blue.$model]
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v.vehicle.tank_ad_blue.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: error.$uid,
                      class: "vuelidate-errors"
                    }, [
                      _createElementVNode("p", _hoisted_46, _toDisplayString(error.$message), 1)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.$t('components.vehicles.modals.tankCapacity')) + " LNG (L)", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.v.vehicle.tank_lng.$model) = $event)),
                    class: _normalizeClass([{ 'custom-error': _ctx.v.vehicle.tank_lng.$error }, "form-control input-sm"]),
                    placeholder: "600",
                    type: "number"
                  }, null, 2), [
                    [_vModelText, _ctx.v.vehicle.tank_lng.$model]
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v.vehicle.tank_lng.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: error.$uid,
                      class: "vuelidate-errors"
                    }, [
                      _createElementVNode("p", _hoisted_49, _toDisplayString(error.$message), 1)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.$t('components.vehicles.modals.tankCapacity')) + " KWh", 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.v.vehicle.tank_kwh.$model) = $event)),
                    class: _normalizeClass([{ 'custom-error': _ctx.v.vehicle.tank_kwh.$error }, "form-control input-sm"]),
                    placeholder: "600",
                    type: "number"
                  }, null, 2), [
                    [_vModelText, _ctx.v.vehicle.tank_kwh.$model]
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v.vehicle.tank_kwh.$errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: error.$uid,
                      class: "vuelidate-errors"
                    }, [
                      _createElementVNode("p", _hoisted_52, _toDisplayString(error.$message), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("button", {
          class: "btn btn-default",
          onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, [
          _cache[16] || (_cache[16] = _createElementVNode("i", { class: "fa fa-remove" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('components.vehicles.modals.exit')), 1)
        ]),
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.editVehicle && _ctx.editVehicle(...args)))
        }, [
          _cache[17] || (_cache[17] = _createElementVNode("i", { class: "fa fa-save" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('components.vehicles.modals.save')), 1)
        ])
      ])
    ]),
    _: 1
  }, 512))
}